import script from "./TeamMemberSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeamMemberSelect.vue?vue&type=script&setup=true&lang=ts"

import "./TeamMemberSelect.vue?vue&type=style&index=0&id=17a57a06&lang=scss"

const __exports__ = script;

export default __exports__